export const PaginationConfig = {
  rowsPerPageOptions: [5, 10, 15, 20],
  defaultRowsPerPage: 10,
  defaultPage: 1,
};
